import { set } from 'lodash';
import { MutationTree } from 'vuex';

export const state = () => ({
  id: null,
  form: {
    readonly: false
  },
  query: {
    where: {
      ownerId: null,
      categoryId: null
    },
    sort: {
      name: 'ASC'
    },
    offset: 0,
    limit: 10,
    include: [
      'rpx-dna-panel',
      'rpx-dna-category',
      'rpx-dna-sub-category',
      'rpx-dna-trait-translation'
    ]
  },
  table: {
    footer: {
      'items-per-page-options': [10, 25, 50, 100],
      'show-current-page': true,
      'show-first-last-page': true,
      // 'page-text': '{{pageStart}}',
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['name'],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      }
    },
    filter: {
      name: '',
      dnaPanelId: [],
      categoryId: [],
      dnaSubCategoryId: []
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['name'],
      sortDesc: [false],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: true
    }
  }
});

export type NutrigeneticTraits = ReturnType<typeof state>;

export const mutations: MutationTree<NutrigeneticTraits> = {
  changeId: (state, id) => (state.id = id),
  changeForm: (state, form) => Object.assign(state.form, form),
  changeQuery: (state, query) => Object.assign(state.query, query),
  changeTableFilter: (state, filter) => {
    Object.assign(state.table, { filter });
    Object.assign(state.query.where, {
      name: filter.name,
      dnaPanelId: filter.dnaPanelId,
      categoryId: filter.categoryId,
      dnaSubCategoryId: filter.dnaSubCategoryId
    });
  },
  changeTableOptions: (state, options) => {
    Object.assign(state.table, { options });
    Object.assign(state.table.footer, { options });
    Object.assign(state.query, {
      sort: set({}, options.sortBy[0], options.sortDesc[0] ? 'DESC' : 'ASC'),
      limit: options.itemsPerPage,
      offset: (options.page - 1) * options.itemsPerPage
    });
  }
};
